import styled from "styled-components";

export const BoxWrapper = styled.div`
    z-index: 2;

    @media screen and (max-width: 860px) {
    display: none;
  }

    .Polaris-ShadowBevel {
        overflow: visible;
        --pc-shadow-bevel-z-index: 1 !important;

            &>.Polaris-Box {
                :first-child {
                border-radius: 0.75rem;
            }
        }
    }

    .Polaris-Box {
        overflow: visible;
    }
`